
/*
 * VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Directive, ElementRef, OnChanges, OnInit, Input } from "@angular/core";

@Directive({ selector: "[vpHighlightWave]" })
export class HighlightWaveDirective implements OnChanges, OnInit {

  @Input() triggerOnClick: boolean = false;
  @Input() highlight: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnChanges(changes) {
    if (changes.highlight)
      this._highlight(this.highlight ? "add" : "remove");
  }

  ngOnInit() {
    this.el.nativeElement.classList.add("vp-highlight-item");

    let div = document.createElement("div");
    div.classList.add("vp-ripple");
    this.el.nativeElement.appendChild(div);

    if (this.triggerOnClick) {
      this.el.nativeElement.onclick = () => {
        this.toggleHighlight();
      };
    }
  }

  toggleHighlight() {
    this.el.nativeElement.classList.toggle("highlight");
  }

  _highlight(fn: string) {
    if (this.el && this.el.nativeElement)
      this.el.nativeElement.classList[fn]("highlight");
  }

}
